module.exports = "/images/call.svg?3ee24b95ef875f90f39dedd6f64da41d";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icons/call.svg
// module id = GLJy
// module chunks = 0 1